import { api } from '../App';

/**
 * Fire-and-forget upgrade-funnel tracker.
 *
 * Always awaited inside the tracker so errors stay contained, never throws
 * to the caller. Callers should NOT await the returned promise; just invoke
 * and move on. The backend silently drops events from non-providers / pro
 * providers so we can be liberal at the call sites.
 *
 * Usage:
 *   useEffect(() => { trackUpgradeEvent('impression', 'earnings_banner'); }, []);
 *   <Button onClick={() => { trackUpgradeEvent('click', 'earnings_banner'); openDialog(); }} />
 */
export function trackUpgradeEvent(eventType, surface) {
  api
    .post('/upgrade-events', { event_type: eventType, surface })
    .catch(() => {
      // Intentionally swallowed, analytics must never break the UX.
    });
}
